import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Clock, Phone, Send } from "lucide-react";
import { toast } from "sonner";
import { STORE } from "../../data/store";

export const Contact = () => {
  const [form, setForm] = useState({ nombre: "", correo: "", mensaje: "" });

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.nombre || !form.correo || !form.mensaje) {
      toast.error("Por favor completa todos los campos.");
      return;
    }
    toast.success(`¡Gracias, ${form.nombre}! Te contactaremos pronto.`);
    setForm({ nombre: "", correo: "", mensaje: "" });
  };

  const mapQuery = encodeURIComponent(
    `${STORE.addressLine1}, ${STORE.addressLine2}`
  );

  return (
    <section
      id="contacto"
      data-testid="contact-section"
      className="relative py-24 md:py-32 bg-[#0A0908]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#A66E38] mb-3">
              Pasa a saludar
            </p>
            <h2 className="font-serif text-3xl md:text-5xl font-bold tracking-tight text-[#F5F0E6] mb-8">
              Visítanos
            </h2>

            <ul className="space-y-6">
              <li className="flex gap-4" data-testid="contact-address">
                <MapPin className="text-[#C89B3C] shrink-0 mt-1" size={22} />
                <div>
                  <p className="text-[#F5F0E6] text-lg">{STORE.addressLine1}</p>
                  <p className="text-[#B8A99A]">{STORE.addressLine2}</p>
                </div>
              </li>
              <li className="flex gap-4">
                <Clock className="text-[#C89B3C] shrink-0 mt-1" size={22} />
                <div>
                  <p className="text-[#F5F0E6]">{STORE.hoursWeek}</p>
                  <p className="text-[#B8A99A]">{STORE.hoursSun}</p>
                </div>
              </li>
              <li className="flex gap-4">
                <Phone className="text-[#C89B3C] shrink-0 mt-1" size={22} />
                <p className="text-[#F5F0E6]">Hollister, California</p>
              </li>
            </ul>

            <a
              href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-map-link"
              className="inline-block mt-8 bg-transparent border border-[#A66E38] text-[#D4B996] hover:bg-[#A66E38]/10 uppercase tracking-widest text-sm py-3 px-7 transition-colors duration-300"
            >
              Ver en el mapa
            </a>
          </motion.div>
        </div>

        <motion.form
          onSubmit={handleSubmit}
          data-testid="contact-form"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="bg-[#1F1A17] border border-white/5 p-8 md:p-10"
        >
          <h3 className="font-serif text-2xl text-[#F5F0E6] mb-6">
            Escríbenos
          </h3>
          <div className="space-y-5">
            <div>
              <label className="block text-sm text-[#B8A99A] mb-2" htmlFor="nombre">
                Nombre
              </label>
              <input
                id="nombre"
                name="nombre"
                type="text"
                value={form.nombre}
                onChange={handleChange}
                data-testid="contact-input-nombre"
                placeholder="Tu nombre"
                className="w-full bg-[#0A0908] border border-white/10 text-[#F5F0E6] focus:border-[#C89B3C] focus:ring-1 focus:ring-[#C89B3C] outline-none placeholder-[#8A7D71] py-3 px-4 transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm text-[#B8A99A] mb-2" htmlFor="correo">
                Correo
              </label>
              <input
                id="correo"
                name="correo"
                type="email"
                value={form.correo}
                onChange={handleChange}
                data-testid="contact-input-correo"
                placeholder="tucorreo@ejemplo.com"
                className="w-full bg-[#0A0908] border border-white/10 text-[#F5F0E6] focus:border-[#C89B3C] focus:ring-1 focus:ring-[#C89B3C] outline-none placeholder-[#8A7D71] py-3 px-4 transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm text-[#B8A99A] mb-2" htmlFor="mensaje">
                Mensaje
              </label>
              <textarea
                id="mensaje"
                name="mensaje"
                rows={4}
                value={form.mensaje}
                onChange={handleChange}
                data-testid="contact-input-mensaje"
                placeholder="¿En qué te podemos ayudar?"
                className="w-full bg-[#0A0908] border border-white/10 text-[#F5F0E6] focus:border-[#C89B3C] focus:ring-1 focus:ring-[#C89B3C] outline-none placeholder-[#8A7D71] py-3 px-4 transition-colors resize-none"
              />
            </div>
            <button
              type="submit"
              data-testid="contact-submit-btn"
              className="w-full flex items-center justify-center gap-2 bg-[#A66E38] hover:bg-[#B88655] text-[#F5F0E6] uppercase tracking-widest text-sm py-4 px-8 transition-colors duration-300"
            >
              Enviar mensaje <Send size={16} />
            </button>
          </div>
        </motion.form>
      </div>
    </section>
  );
};
